import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VehicleList } from '../../../api/models/vehicle-list';
import { FormGroup } from '@angular/forms';
import { max } from 'rxjs/operators';
import { IVehicleFilter } from '../../../api/models/filters';

@Component({
    selector: 'app-accordion-list',
    templateUrl: './accordion-list.component.html',
    styleUrls: ['./accordion-list.component.scss']
})

export class AccordionListComponent implements OnInit {

    @Input() items: IVehicleFilter[];
    @Input() notAllowed: string[] = [];
    @Input() allowed: string[] = [];
    @Input() parentForm: FormGroup;
    @Input() fieldname: string;
    @Input() saveSearch: any;
    @Input() useNameCase: boolean = false;
    @Output() selectFilters: EventEmitter<any> = new EventEmitter<any>();

    get validItems (): IVehicleFilter[] {
        return this.items && this.items.filter(x => this.isAllowed(x));
    }

    constructor() { }

    ngOnInit() { }

    getActiveItem(value?: string, fieldname?: string, minval?: number, maxval?: number) {

        if (fieldname ===  'mileages') {

            this.selectFilters.emit(
                {
                    minMileage: minval,
                    maxMileage: maxval
                }
            );

        } else if (fieldname ===  'prices') {

            this.selectFilters.emit(
                {
                    minPrice: minval,
                    maxPrice: maxval
                }
            );

        } else {

            this.selectFilters.emit(
                {
                    [fieldname]: value
                }
            );

        }

    }

    getValue(name, fieldname, minval, maxval) {
        if (fieldname ===  'mileages') {
            return {
                minMileage: minval,
                maxMileage: maxval
            };
        } else if (fieldname ===  'prices') {
            return {
                minPrice: minval,
                maxPrice: max
            };
        } else {
            return name;
        }
    }
    
    isAllowed (item: IVehicleFilter): boolean {
        if (this.allowed && this.allowed.length > 0) {
            return this.allowed.map(x => x.toLowerCase()).indexOf(item.Name.toLowerCase()) != -1;
        }
        if (this.allowed && this.notAllowed.length > 0) {
            return this.notAllowed.map(x => x.toLowerCase()).indexOf(item.Name.toLowerCase()) == -1;
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/accordion-list/accordion-list.component.ts